class e{canDebug=Boolean(process.env.REACT_APP_DEBUG);err(e){this.canDebug&&console.error(e)}log(e){this.canDebug&&console.log(e)}warn(e){this.canDebug&&console.warn(e)}}export{e as Logger};
//# sourceMappingURL=logger.js.map
